import { render, staticRenderFns } from "./ListOptionsDialog.vue?vue&type=template&id=bb6b510c&scoped=true&"
import script from "./ListOptionsDialog.vue?vue&type=script&lang=js&"
export * from "./ListOptionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b510c",
  null
  
)

export default component.exports